<template>
  <div class="reset-password-container">

    <CustomModal 
    :type="modal_type"
    :open="modal_open"
    @close-modal="modal_open = false">
      <template slot="modal_content">
        <p class="notification-text">{{modal_message}}</p>
      </template>
    </CustomModal>

    <h3>{{$_('reinit_my_password')}}</h3>
    <form @submit.prevent="vResetPassword">
      <div class="password-container">
        <div class="form-field">
          <label>{{$_('password')}}</label>
          <input type="password" v-model="password" />
        </div>
        <div class="form-field">
          <label>{{$_('password_confirm')}}</label>
          <input type="password" v-model="confirm_password" />
        </div>
        <div class="form-field">
          <input type="submit" :value="$_('send').toUpperCase()" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import authService from "@/modules/authentification/services/authService";
import CustomModal from '@/common/components/widget/Modal/CustomModal';

export default {
  data() {
    return {
      password: '',
      confirm_password: '',
      modal_type: 'default',
      modal_open: false,
      modal_message: ''
    }
  },
  components: {
    CustomModal
  },
  methods: {
    vResetPassword() {
      if(this.password.length < 6) {
        this.modal_type = 'error';
        this.modal_message = this.$_('password_length_error');
        this.modal_open = true;
        return false;
      }

      if(this.password === this.confirm_password) {
        authService.setNewPassword(
          this.password,
          this.$route.query.session_id,
          this.$route.query.md5
        )
        .then(res => {
          if(res.data !== undefined && res.data.POK === 0) {
            this.modal_type = 'error';
            this.modal_message = this.$_('reinit_password_error');
          } else {
            this.modal_type = 'success';
            this.modal_message = this.$_('reinit_password_success');
          }
          this.modal_open = true;

          setTimeout(() => {
            this.modal_open = false;
            this.$router.push('/login');
          }, 5000);
        })
      }
    }
  }
};
</script>

<style scoped>
.reset-password-container {
  width: 500px;
  background-color: #fff;
  padding: 30px;
  margin: auto;
  border-radius: 4px;
}
h3 {
  margin-bottom: 10px;
}
</style>